// Google Ads Conversion Tracking Configuration
// Add programs here to enable conversion tracking for specific booking types
const conversionTrackingConfig = {
  googleAdsId: "AW-17883377101",
  // Conversion label from Google Ads (update this after creating conversion action in Google Ads)
  conversionLabel: "rNQYCMDh_OcbEM3bus9C",
  currency: "INR",
  // Programs that should trigger conversion events
  // Each entry specifies: program name and optionally the booking type (joyRide, shuttle, or both)
  trackedPrograms: [
    // Add programs as needed: { program: "MAGH_MELA", type: "joyRide" }, { program: "UACS", type: "shuttle" }, etc.
  ],
};

// Meta Pixel (Facebook) Tracking Configuration
// Used for tracking PageView, InitiateBooking, and Booked events
const metaPixelConfig = {
  pixelId: "25288106204222798",
  currency: "INR",
  // Programs that should trigger Meta Pixel conversion events
  // Each entry specifies: program name and optionally the booking type (joyRide, shuttle, or both)
  trackedPrograms: [
    // Add programs as needed: { program: "MAGH_MELA", type: "joyRide" }, etc.
  ],
  // Partner (Thumby) pixel for the "Kerala by Air" campaign.
  // This is a separate Meta ad account: it receives PageView / InitiateCheckout /
  // Purchase for the programs listed below and nothing else. Our own pixel above
  // deliberately does not receive these events.
  partner: {
    pixelId: "1579956383580490",
    trackedPrograms: [{ program: "KERALA_BY_SKY", type: "joyRide" }],
  },
};

const getConfig = () => {
  if (process.env.REACT_APP_ENV === "dev") {
    return {
      // baseUrl: "https://api.helitaxii.com/",
      baseUrl: "http://localhost:8081/",
      firebaseConfig: {
        apiKey: "AIzaSyBsO3j9hCtkTFnFYJFAwWpqoUzocfdvMow",
        authDomain: "helitaxii-dev.firebaseapp.com",
        projectId: "helitaxii-dev",
        storageBucket: "helitaxii-dev.appspot.com",
        messagingSenderId: "842170867801",
        appId: "1:842170867801:web:521cc56fc5cc2b7e335148",
      },
      conversionTracking: {
        ...conversionTrackingConfig,
        enabled: false, // Disabled in dev
      },
      metaPixel: {
        ...metaPixelConfig,
        enabled: false, // Disabled in dev
      },
    };
  }

  if (process.env.REACT_APP_ENV === "staging") {
    return {
      baseUrl: "https://sandbox.helitaxii.com/",
      firebaseConfig: {
        apiKey: "AIzaSyBsO3j9hCtkTFnFYJFAwWpqoUzocfdvMow",
        authDomain: "helitaxii-dev.firebaseapp.com",
        projectId: "helitaxii-dev",
        storageBucket: "helitaxii-dev.appspot.com",
        messagingSenderId: "842170867801",
        appId: "1:842170867801:web:521cc56fc5cc2b7e335148",
      },
      conversionTracking: {
        ...conversionTrackingConfig,
        enabled: false, // Disabled in staging
      },
      metaPixel: {
        ...metaPixelConfig,
        enabled: false, // Disabled in staging
      },
    };
  }

  if (process.env.REACT_APP_ENV === "production") {
    return {
      baseUrl: "https://api.helitaxii.com/",
      firebaseConfig: {},
      conversionTracking: {
        ...conversionTrackingConfig,
        enabled: true, // Only enabled in production
      },
      metaPixel: {
        ...metaPixelConfig,
        enabled: true, // Only enabled in production
      },
    };
  }
};

export default getConfig();
